module.exports = __webpack_public_path__ + "img/safari-tip.b5aabad3.png";